<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="isVisible" class="z-49 pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white ring-1 shadow-lg ring-black/5">
      <div class="p-4">
        <div class="flex items-start">
          <div class="shrink-0" v-if="notification.icon !== 'none'">
            <ShareIcon v-if="notification.icon === 'social'" class="size-6 text-purple-400" aria-hidden="true" />
            <InformationCircleIcon v-else class="size-6 text-blue-400" aria-hidden="true" />
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900">{{ notification.title }}</p>
            <p class="mt-1 text-sm text-gray-500" v-html="notification.message"></p>
          </div>
          <div class="ml-4 flex shrink-0">
            <button 
              type="button" 
              @click="dismiss" 
              class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
            >
              <span class="sr-only">Закрити</span>
              <XMarkIcon class="size-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { ShareIcon, InformationCircleIcon } from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { dismissNotification, markNotificationAsShown } from '@/data/requests/notifications'

export default {
  name: 'ToastNotificationComponent',
  components: {
    ShareIcon,
    InformationCircleIcon,
    XMarkIcon,
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  emits: ['dismissed'],
  setup(props, { emit }) {
    const isVisible = ref(false)
    let autoHideTimer = null

    const dismiss = () => {
      if (autoHideTimer) {
        clearTimeout(autoHideTimer)
        autoHideTimer = null
      }

      dismissNotification(
        props.notification.key,
        () => {
          isVisible.value = false
          emit('dismissed', props.notification.key)
        },
        (type, data) => {
          console.error('Помилка при відмітці сповіщення:', type, data)
          // Все одно приховуємо сповіщення навіть якщо запит не вдався
          isVisible.value = false
          emit('dismissed', props.notification.key)
        }
      )
    }

    const startAutoHide = () => {
      if (props.notification.duration && props.notification.duration > 0) {
        autoHideTimer = setTimeout(() => {
          dismiss()
        }, props.notification.duration)
      }
    }

    onMounted(() => {
      // Позначаємо сповіщення як показане
      markNotificationAsShown(
        props.notification.key,
        () => {
          // Успішно позначено як показане
        },
        (type, data) => {
          console.error('Помилка при позначенні сповіщення як показаного:', type, data)
        }
      )
      
      // Показуємо сповіщення з невеликою затримкою для плавної анімації
      setTimeout(() => {
        isVisible.value = true
        startAutoHide()
      }, 100)
    })

    onUnmounted(() => {
      if (autoHideTimer) {
        clearTimeout(autoHideTimer)
      }
    })

    return {
      isVisible,
      dismiss
    }
  }
}
</script>


